// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Product_container__qYPql {
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 8px;
  padding: 12px 16px 21px;
  transition: all 0.2s linear;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.Product_container__qYPql .Product_imgWrapper__3qUPH {
  align-items: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  height: 240px;
  justify-content: center;
  transition: transform 0.5s;
}
.Product_container__qYPql .Product_imgWrapper__3qUPH:hover {
  transform: scale(1.07);
}
.Product_container__qYPql .Product_chestTitleWrapper__z9BGv {
  border-bottom: 1px solid rgba(220, 220, 220, 0.1);
  margin-top: 18px;
  padding-bottom: 12px;
}
.Product_container__qYPql .Product_chestTitleWrapper__z9BGv .Product_chestTitle__hbNPm {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.Product_container__qYPql .Product_chestTitleWrapper__z9BGv .Product_chestTitle__hbNPm .Product_chestName__YMWUG {
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
  color: #FD4C0A;
  height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Product_container__qYPql img {
  width: 100%;
}
.Product_container__qYPql .Product_productName__G15AD {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  margin-bottom: 12px;
  margin-top: 12px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Product_container__qYPql .Product_questTask__Hwaz4 {
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  color: #e0e0e0;
  margin-bottom: 8px;
  max-width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  white-space: normal;
  text-overflow: ellipsis;
  flex-grow: 1;
}
.Product_container__qYPql .Product_readMoreBtn__eO9R7 {
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  color: #ead40c;
  font-weight: 500;
  font-size: 14px;
  border: none;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 12px;
}
.Product_container__qYPql .Product_productPrice__Jz1pM {
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
  color: #FD4C0A;
  margin-top: 24px;
}
.Product_container__qYPql .Product_btn__UQPdb {
  margin-top: auto;
}
.Product_container__qYPql .Product_btn__UQPdb button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  background-color: #FD4C0A;
  border-radius: 8px;
  cursor: pointer;
  height: 46px;
  transition: all 0.2s linear;
  width: 100%;
  color: #FFFFFF;
}
.Product_container__qYPql .Product_btn__UQPdb button .Product_loader__gFX5P {
  animation: Product_spin__L13uD 0.5s linear infinite;
  width: 24px;
}
.Product_container__qYPql .Product_btn__UQPdb button:hover {
  transform: scale(1.02);
}

@keyframes Product_spin__L13uD {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Product/Product.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,oCAAA;EACA,kCAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AADF;AAGE;EACE,mBAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA;AADJ;AAGE;EACE,sBAAA;AADJ;AAIE;EACE,iDAAA;EACA,gBAAA;EACA,oBAAA;AAFJ;AAII;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;AAFN;AAIM;ECNJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDMM,cE9BG;EF+BH,YAAA;EACA,gBAAA;EACA,uBAAA;AAAR;AAKE;EACE,WAAA;AAHJ;AAME;ECFA,eAAA;EACA,gBAAA;EACA,kBAAA;EDEE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAFJ;AAKE;ECMA,eAAA;EACA,gBAAA;EACA,kBAAA;EDNE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AADJ;AAIE;ECTA,eAAA;EACA,gBAAA;EACA,kBAAA;EDSE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;AAAJ;AAGE;ECxDA,eAAA;EACA,gBAAA;EACA,kBAAA;EDyDE,cEjFO;EFkFP,gBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAEI;EC/CF,eAAA;EACA,gBAAA;EACA,kBAAA;EDgDI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;EACA,cAAA;AACN;AACM;EACE,mDAAA;EACA,WAAA;AACR;AAEM;EACE,sBAAA;AAAR;;AAWA;EACE;IACE,uBAAA;EARF;EAWA;IACE,yBAAA;EATF;AACF","sourcesContent":["@import \"../../assets/styles/global.scss\";\n\n.container {\n  background-color: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 8px;\n  padding: 12px 16px 21px;\n  transition: all 0.2s linear;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n\n  .imgWrapper {\n    align-items: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    display: flex;\n    height: 240px;\n    justify-content: center;\n    transition: transform 0.5s;\n  }\n  .imgWrapper:hover {\n    transform: scale(1.07);\n  }\n\n  .chestTitleWrapper {\n    border-bottom: 1px solid rgba(220, 220, 220, 0.1);\n    margin-top: 18px;\n    padding-bottom: 12px;\n\n    .chestTitle {\n      align-items: center;\n      display: flex;\n      justify-content: space-between;\n\n      .chestName {\n        @include subtitle3b;\n        color: $c-yellow;\n        height: 24px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  img {\n    width: 100%;\n  }\n\n  .productName {\n    @include subtitle6m;\n    color: #ffffff;\n    margin-bottom: 12px;\n    margin-top: 12px;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .questTask {\n    @include body2;\n    color: #e0e0e0;\n    margin-bottom: 8px;\n    max-width: 100%;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    white-space: normal;\n    text-overflow: ellipsis;\n    flex-grow: 1;\n  }\n\n  .readMoreBtn {\n    @include body2;\n    color: #ead40c;\n    font-weight: 500;\n    font-size: 14px;\n    border: none;\n    cursor: pointer;\n    display: inline-block;\n    margin-bottom: 12px;\n  }\n\n  .productPrice {\n    @include subtitle3b;\n\n    color: $c-yellow;\n    margin-top: 24px;\n  }\n\n  .btn {\n    margin-top: auto;\n    button {\n      @include subtitle6m;\n\n      background-color: #FD4C0A;\n      border-radius: 8px;\n      cursor: pointer;\n      height: 46px;\n      transition: all 0.2s linear;\n      width: 100%;\n      color: #FFFFFF;\n\n      .loader {\n        animation: spin 0.5s linear infinite;\n        width: 24px;\n      }\n\n      &:hover {\n        transform: scale(1.02);\n      }\n    }\n  }\n\n  // &:hover {\n  //   // border: 1px solid #ead40c;\n  //   transform: scale(1.02);\n  // }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #FD4C0A;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Product_container__qYPql`,
	"imgWrapper": `Product_imgWrapper__3qUPH`,
	"chestTitleWrapper": `Product_chestTitleWrapper__z9BGv`,
	"chestTitle": `Product_chestTitle__hbNPm`,
	"chestName": `Product_chestName__YMWUG`,
	"productName": `Product_productName__G15AD`,
	"questTask": `Product_questTask__Hwaz4`,
	"readMoreBtn": `Product_readMoreBtn__eO9R7`,
	"productPrice": `Product_productPrice__Jz1pM`,
	"btn": `Product_btn__UQPdb`,
	"loader": `Product_loader__gFX5P`,
	"spin": `Product_spin__L13uD`
};
export default ___CSS_LOADER_EXPORT___;
